<template>
  <div  style="background-color: white">
    <nav class="bar bar-nav border">
      <div class="labeldiv top" style="margin-left:0.5rem;font-weight: bold" >{{this.$route.query.label}}</div>
      <div class="top" style="float: right;margin-bottom: 0rem;height: 0.8rem"  v-if="id !== 20">
        <div class="search-input" v-if="!showSearchBar">
          <label class="icon icon-search" for="search"></label>
          <input style="background-color: #F6F6F7;"  type="search" id='search' v-if="id === 3  || id === 2 || id === 12 || id === 1 " placeholder="输入基因名称..."  class="open-popup open-goods" data-popup=".popup-goods" readonly unselectable="on" />
          <input style="background-color: #F6F6F7;"  type="search" id='search' v-else-if="id ===6"  placeholder="输入细胞名称..." class="open-popup open-goods" data-popup=".popup-goods" readonly unselectable="on" />
          <input style="background-color: #F6F6F7;"  type="search" id='search' v-else  class="open-popup open-goods" data-popup=".popup-goods" readonly unselectable="on" />
        </div>
      </div>
      <div class="top" style="float: right;margin-bottom: 0rem;height: 0.8rem"  v-else>
        <router-link class="tab-item" :to="{ name: 'finder'}">
          <div class="search-input" style="margin-top: 0.5rem">
            <label class="icon icon-search" for="search"></label>
            <input type="search" id='search' placeholder='输入基因名称...' readonly unselectable="on"/>
          </div>
        </router-link>
      </div>
    </nav>
    <div class="content top">
      <div style="margin-bottom: 3rem;overflow: scroll;height: 100%;" :style="{'margin-bottom': emkt.leaveSpaceForFullScreen ? '4rem' : '3rem'}">
          <!--<merchdata :merchList="catagoryList" :showFilterBar="showSearchBar" :showFilterBarForKit="showFilterBarForKit"></merchdata>-->
        <newMerchandiseListA :merchList="catagoryList" :showFilterBar="showSearchBar" :showFilterBarForKit="showFilterBarForKit"></newMerchandiseListA>
          <div class="button"  @click="loadmore">更多...</div>
          <div id="over" style="text-align: center;"></div>
       </div>
    </div>
  </div>
</template>
<script>
  import $ from 'jquery'
  import emkt from '../../emkt.js'
  import merchdata from '../../components/MerchandiseList.vue'
  import newMerchandiseListA from '../finder/components/NewMerchandiseListA.vue'
  import {mapState, mapMutations} from 'vuex'
  import wx from 'wx'
  export default {
    mounted () {
      // console.log('mounted')
    },
    created () {
      this.fetchData()
    },
    data () {
      return {
        Merchandises: [],
        tabs1: [],
//        tabs2: [],
        catagoryList: [],
        description: '',
        id: this.$route.query.id,
        total: 0
      }
    },
    watch: {
      // 如果路由有变化，会再次执行该方法
      // '$route': 'fetchData'
      'merchandiseQueryParams': function () {
        let _this = this
        let params = this.merchandiseQueryParams
        let id = params.categoryId
        if (id) {
          if (id === 6) {
            if (emkt.isWapp) {
              wx.miniProgram.switchTab({
                url: '/pages/cart/cart'
              })
            } else {
              this.$router.replace({name: 'cart'})
            }
          } else {
            let query = this.$route.query
            if (query.filterName && query.filterName === 'promotionGuid') {
              params = {'promotionGuid': query.filterValue, 'fromIndex': 0}
            } else {
              params = {'categoryId': params.categoryId, 'filterConditions': params.filterConditions}
            }
            console.log('params', params)
            console.log('query', query)
            this.gcapi('queryMerchandise', params).then((res) => {
              if (res.body.code === 0) {
                _this.catagoryList = res.body.result.merchandiseList
                _this.catagoryList.sort(function (o1, o2) {
                  return o1.selfOperated - o2.selfOperated
                })
                _this.total = res.body.result.total
                let data = {}
                data['total'] = this.total
                data['category'] = res.body.result.categoryIdToCount
                this.QUERY_TOTAL(data)
              }
            })
          }
        }
      }
    },
    components: {
      merchdata, newMerchandiseListA
    },
    computed: {
      ...mapState([
        'merchandiseQueryParams'
      ]),
      showSearchBar () {
        let flag = false
        let id = parseInt(this.id)
        /*
          以下产品大类暂不显示查询bar
          5 ===》 aav ；7 ===》 支原体 ；8 ===》 cas9文库 ；9 ===》 工具类病毒 ；
         */
        if (id === 5 || id === 8 || id === 9 || id === 7 || id === 14) {
          flag = true
        }
        return flag
      },
      showFilterBarForKit () {
        // let id = parseInt(this.id)
        let flag = false
        // if (id && id === 7) {
        //   flag = true
        // }
        return flag
      }
    },
    methods: {
      ...mapMutations([
        'QUERY_TOTAL'
      ]),
      fetchData () {
        if (this.$route.query.id === 20) {
          this.$router.replace({name: 'finder'})
          return
        }
        if (this.$route.query.id === 6) {
          this.$weui.topTips('细胞相关产品已经下架！', 3000)
          if (emkt.isWapp) {
            wx.miniProgram.switchTab({
              url: '/pages/cart/cart'
            })
          } else {
            this.$router.replace({name: 'cart'})
          }
        }
        let params = {categoryId: this.$route.query.id}
        let query = this.$route.query
        if (query.filterName && query.filterName === 'promotionGuid') {
          params = {'promotionGuid': query.filterValue, 'fromIndex': 0}
        }
        console.log('params', params)
        console.log('query', query)
        this.gcapi('queryMerchandise', params).then((response) => {
          this.id = this.$route.query.id
          this.catagoryList = response.body.result.merchandiseList
          this.total = response.body.result.total
          for (var i = 0; i < this.catagoryList.length; i++) {
            var tags = []
            var merchandiseMeta = emkt.getEmktMetaData()
            var tagsmap = merchandiseMeta.tagsMap
            for (var j = 0; j < this.catagoryList[i].tagIds.length; j++) {
              tags.push(tagsmap[this.catagoryList[i].tagIds[j]].tagLabel)
            }
            this.catagoryList[i].tags = tags
          }
          this.catagoryList.sort(function (o1, o2) {
            return o1.selfOperated - o2.selfOperated
          })
          if (this.catagoryList.length < 20) {
            $('.button').remove()
          }
          let data = {}
          data['total'] = this.total
          data['category'] = response.body.result.categoryIdToCount
          this.QUERY_TOTAL(data)
        })
      },
      loadmore () {
        var fromindex = this.catagoryList.length
        if (fromindex >= this.total) {
          $('.button').remove()
          $('#over').append('已经到底啦！')
          return
        } else {
          var addlist = []
          let params = {categoryId: this.id, fromIndex: fromindex}
          let query = this.$route.query
          if (query.filterName && query.filterName === 'promotionGuid') {
            params = {'promotionGuid': query.filterValue, 'fromIndex': 0}
          }
          this.gcapi('queryMerchandise', params).then((response) => {
            addlist = response.body.result.merchandiseList
            for (var i = 0; i < addlist.length; i++) {
              var tags = []
              var merchandiseMeta = emkt.getEmktMetaData()
              var tagsmap = merchandiseMeta.tagsMap
              for (var j = 0; j < addlist[i].tagIds.length; j++) {
                tags.push(tagsmap[addlist[i].tagIds[j]].tagLabel)
              }
              addlist[i].tags = tags
              this.catagoryList.push(addlist[i])
            }
            let data = {}
            data['total'] = this.total
            data['category'] = response.body.result.categoryIdToCount
            this.QUERY_TOTAL(data)
          })
        }
      }
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .content {
    background-color: white
  }
  hr {
    height:0.08rem;
    border:0.08rem;
    background-color:#00469A;
  }
  .button{
    color: #0a8ddf;
    border: 0rem;
    font-size: 1rem
  }
  .labeldiv {
    margin-left: 0.2rem;
    margin-bottom: 0rem;
    color: #00469A;
    font-size: 1.2rem;
    float: left
  }
  .border{
    border-bottom: 0.08rem solid #00469A;  height: 2.4rem;
  }
  .top{
    margin-top: 0.2rem;
  }
</style>



// WEBPACK FOOTER //
// CategoryDetail.vue?13db2bd6